import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=2c76c14b"
import script from "./payments.vue?vue&type=script&lang=js"
export * from "./payments.vue?vue&type=script&lang=js"
import style0 from "./payments.vue?vue&type=style&index=0&id=2c76c14b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports